module.exports = __webpack_public_path__ + "img/dazi_img2.2fdb1072.png";